// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ZPP5N","bg":"styles_bg__LSc7E","container":"styles_container__33grW"};